import {typeExport} from "../../../../../redux/store/type";


const reducerListServiceHistorySatiaScreen = (state = {
  empty: false,
    failed: false,
    lazyload_end: false,
    NoInternetDialog: false, page:1,
    results: [],
    showLoading: false,
    showRefresh: false,

    isLoadingSet: false,
    NoInternetDialogSet: false,
    resultsSet: null,
    notif: false,
    id: 0,
    ListFilter: []
}, action) => {
    const newState = {...state};
    switch (action.type) {
        case typeExport.ListServiceHistorySatiaScreen_SERVICE_PENDING:
            return {
                ...state,
                NoInternetDialog: false,
                showLoading: true,
                showRefresh: false,
                failed: false,
                empty: false,
                lazyload_end: false,

            };
        case typeExport.ListServiceHistorySatiaScreen_SERVICE_ERROR:
            return {
                ...state,
                NoInternetDialog: action.page === 1 ? true : false,
                showLoading: false,
                showRefresh: false,
                failed: action.page === 1 ? false : true,
                lazyload_end: true,
                empty: false,
                page: action.page
            };
        case typeExport.ListServiceHistorySatiaScreen_SERVICE_SUCCESS:
            return {
                ...state,
                results: action.page === 2 ? action.results : [...state.results, ...action.results],
                NoInternetDialog: false,
                showLoading: false,
                showRefresh: false,
                failed: false,
                lazyload_end: false,
                empty: false,
                page: action.page
            };
        case typeExport.ListServiceHistorySatiaScreen_SERVICE_END:
            return {
                ...state,
                //results: state.results,
                results: action.page === 2 ? action.results : [...state.results, ...action.results],
                NoInternetDialog: false,
                showLoading: false,
                showRefresh: false,
                failed: false,
                lazyload_end: true,
                empty: false,
                page: action.page
            };
        case typeExport.ListServiceHistorySatiaScreen_SERVICE_REFRESH:
            return {
                ...state,
                results: [],
                NoInternetDialog: false,
                showLoading: false,
                showRefresh: false,
                failed: false,
                lazyload_end: false,
                empty: false,
                page: action.page,
                id: 0,
              //  ListFilter: [],

            };
        case typeExport.ListServiceHistorySatiaScreen_SERVICE_Empty:
            return {
                ...state,
                results: state.results,
                NoInternetDialog: false,
                showLoading: false,
                showRefresh: false,
                failed: false,
                lazyload_end: true,
                empty: true,
                page: action.page
            };
        case typeExport.ListServiceHistorySatiaScreen_SERVICE_ADD_FIRST_DATA:
            return {
                ...state,
                results: action.results,
                NoInternetDialog: false,
                showRefresh: false,
                failed: false,
                lazyload_end: action.lazyload_end,
                showLoading: action.showLoading,
                empty: action.empty,
                page: action.page
            };
        case typeExport.SetListServiceHistorySatiaScreen_SERVICE_PENDING:
            return {
                ...state,
                NoInternetDialogSet: action.NoInternetDialogSet,
                isLoadingSet: action.isLoadingSet,
                resultsSet: action.resultsSet,
                id: action.id
            };
        case typeExport.SetListServiceHistorySatiaScreen_SERVICE_ERROR:
            return {
                ...state,
                NoInternetDialogSet: action.NoInternetDialogSet,
                isLoadingSet: action.isLoadingSet,
                error: action.error
            };


        case typeExport.SetListServiceHistorySatiaScreen_SERVICE_SUCCESS:

            newState.NoInternetDialogSet = action.NoInternetDialogSet;
            newState.resultsSet = action.resultsSet;
            newState.isLoadingSet = action.isLoadingSet;
            newState.id = 0;
            newState.results =
                newState.results.map((val, key) => {
                    if (val.id === action.id) {
                        val.apply_notify = action.resultsSet.apply_notify;
                        return val;
                    }
                    return val;
                });

            return newState

        case typeExport.ListServiceHistorySatiaScreen_SERVICE_CHANGE_NOTIF:


            newState.results =
                newState.results.map((val, key) => {
                    if (key === action.index) {
                        val.status = action.data;
                        return val;
                    }
                    return val;
                })

            return newState;
        case typeExport.ListServiceHistorySatiaScreen_SERVICE_AddSubList:

            return {
                ...state,
                results: action.data,
                showLoading: false,
                lazyload_end: (action.data.length < 10) ? true : false,
            };

        case typeExport.ListServiceHistorySatiaScreen_SERVICE_LIST_FILTER:

            return {
                ...state,
                ListFilter: action.ListFilter,

            };


        default:
            return state;
    }
}

export default reducerListServiceHistorySatiaScreen;
